var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.2 167.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0{fill:#34313f}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.1 95.2h21.1c6 0 9.8-3.3 9.8-8.6 0-5-3.8-8.6-9.8-8.6H88.1c-.7 0-1.3.6-1.3 1.2V94c.1.7.6 1.2 1.3 1.2zM88.1 129.3h21.8c6.7 0 10.7-3.4 10.7-9.4 0-5.2-3.8-9.4-10.7-9.4H88.1c-.7 0-1.3.6-1.3 1.2V128c.1.8.6 1.3 1.3 1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.3.4l-62.4 62.2h10.2c15.9 0 25.3 10 25.3 20.9 0 8.6-5.8 14.9-12 17.7-1 .4-1 1.8.1 2.2 7.2 2.8 12.3 10.3 12.3 19.1 0 12.4-8.3 22.3-24.4 22.3H70.2c-.7 0-1.3-.6-1.3-1.2V96.5L.4 164.7c-.9.9-.3 2.5 1 2.5h164.7c.6 0 1.1-.5 1.1-1.1V1.3c.3-1.1-1.1-1.7-1.9-.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcommerce);
export default __webpack_public_path__ + "static/media/bigcommerce.e7a8011c.svg";
export { ForwardRef as ReactComponent };